import { EVENT_ICONS, EVENT_COLORS, type EventType } from '@/lib/constants';
import { cn } from '@/lib/utils';

interface EventIconProps {
  eventType: EventType;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
};

const iconSizes = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

export function EventIcon({ eventType, size = 'md', className }: EventIconProps) {
  const Icon = EVENT_ICONS[eventType] || EVENT_ICONS['custom'];
  const colorClass = EVENT_COLORS[eventType] || EVENT_COLORS['custom'];

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full',
        sizeClasses[size],
        colorClass,
        className
      )}
    >
      <Icon className={iconSizes[size]} />
    </div>
  );
}
